import { render, staticRenderFns } from "./BlackGoldPageLoader.vue?vue&type=template&id=5125c28d&"
import script from "./BlackGoldPageLoader.vue?vue&type=script&lang=js&"
export * from "./BlackGoldPageLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports